import { Box, Typography } from "@mui/material";
import notSecretaries from "../../../../assets/image/notSecretaries.png";

export default function Secretaries() {
  return (
    <>
      <Typography
        mt="40px"
        //   onClick={() => setSelected(0)}
        className={"styleSelectedTab"}
      >
        {"منشی بخش"}
      </Typography>
      <Box
        height="70vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <img src={notSecretaries} style={{ marginTop: "50px" }} />
      </Box>
      {/* <Box className={`doctor`}  width="100px" height="100px" /> */}
    </>
  );
}
